import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6498745d"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["accept", "multiple"]

import { computed, PropType, ref } from "vue";
import { FileUploaderExtension } from "./types";
import { allExtensions, videoExtensions } from "./constants";
import { FileUploaderErrorTypeEnum } from "./enums";


export default /*#__PURE__*/_defineComponent({
  __name: 'tir-pm-file-uploader',
  props: {
  /**Допустимые расширения */
  allowedExtensions: {
    type: Array as PropType<Array<FileUploaderExtension>>,
    default: (): Array<FileUploaderExtension> => allExtensions,
  },
  /**Максимальный размер файла */
  maxSize: {
    type: Number,
    default: 26214400.01, // 25 МБ
  },
  /**Доступен выбор нескольких файлов */
  isMultiple: {
    type: Boolean,
    default: false,
  },
  /**Заблокировать */
  isDisabled: {
    type: Boolean,
    default: false,
  },
},
  emits: ["uploadFiles", "onError"],
  setup(__props, { emit }) {

const props = __props;





const $input = ref<HTMLInputElement>();

const inputFile = () => {
  if (props.isDisabled || !$input.value) return;
  $input.value.click();
};

const allowedExtensionsString = computed(() =>
  props.allowedExtensions.map((ext) => `.${ext}`).join(",")
);

const handleFileChange = (event: any) => {
  if (!event?.target?.files?.length) return;
  const eventFiles = event.target.files as Array<File>;
  const filesToUpload = new Array<File>();

  for (let index = 0; index < eventFiles.length; index++) {
    const file = eventFiles[index];
    if (file) {
      const fileExtension = file.name.split(".").pop().toLowerCase();
      if (props.allowedExtensions.some((ext) => ext === fileExtension)) {
        if (videoExtensions.some((ext) => ext === fileExtension) || file.size <= props.maxSize) {
          filesToUpload.push(file);
        } else {
          emit("onError", FileUploaderErrorTypeEnum.LimitSize, file);
        }
      } else {
        emit("onError", FileUploaderErrorTypeEnum.NoValidExtension, file);
      }
    }
  }

  if (filesToUpload.length) {
    emit("uploadFiles", filesToUpload);
  }
  event.target.value = "";
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "tir-pm-file-uploader",
    onClick: inputFile
  }, [
    _createElementVNode("input", {
      ref_key: "$input",
      ref: $input,
      class: "tir-pm-file-uploader__input",
      type: "file",
      accept: allowedExtensionsString.value,
      onChange: handleFileChange,
      multiple: __props.isMultiple
    }, null, 40, _hoisted_1),
    _renderSlot(_ctx.$slots, "default")
  ]))
}
}

})